var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessageImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 113,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.222 31.131-1.702 13.86c-.155 1.264 1.383 1.999 2.259 1.08l7.833-8.2 2.18-.805 26.075-28.872.715-2.406-3.853 1.564-33.375 22.642-.132 1.137z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.204 5.848c-.063.017-45.128 16.027-45.19 16.048a1.325 1.325 0 0 0-.384 2.287l8.686 6.12 37.965-23.991c-.31-.342-.538-.613-1.077-.464z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.086 6.22c-.017-.02-.253-.012-.27-.032l-29.204 31.684 14.603 11.29c.717.583 1.78.242 2.056-.64l13.13-41.37c.139-.437-.05-.594-.315-.931z",
    fill: "#FC3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.746 60.719c20.03 30.081 43.072 46.923 69.123 50.524 39.076 5.402 53.68-39.91 46.378-57.264-7.302-17.355-19.295-5.158-13.299 10.17 5.997 15.329 30.115 40.926 75.464 37.004 30.233-2.615 58.775-18.34 85.625-47.174",
    stroke: "#403F4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5,10"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageImage);
export default __webpack_public_path__ + "static/media/send-message-image.486e752f.svg";
export { ForwardRef as ReactComponent };